export const VNTENDERS_SET_REOPENED_TAB_PAYMENTS = 'VNTENDERS_SET_REOPENED_TAB_PAYMENTS'
